import { render, staticRenderFns } from "./adminlist.vue?vue&type=template&id=96e76632&"
import script from "./adminlist.vue?vue&type=script&lang=js&"
export * from "./adminlist.vue?vue&type=script&lang=js&"
import style0 from "./adminlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports